module.exports = __webpack_public_path__ + "img/unitedstates-fw.9069001.png";